// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import LazyLoad from "react-lazy-load";
import type { $TransformedBlogPost } from "flow/types";

type $Props = {
  post: $TransformedBlogPost,
  classes: Object,
};

const Post = ({ classes, post }: $Props) => (
  <a key={post.id} className={classes.root} href={`/blog/post/${post.id}`}>
    <div className={classes.image}>
      <LazyLoad offset={100}>
        <img
          src={
            post.image ||
            "https://storage.googleapis.com/branding/elevate-placeholder.svg"
          }
          alt={post.title}
        />
      </LazyLoad>
    </div>
    <div className={classes.content}>
      <Typography type="heading6" gutterBottom>
        {post.title}
      </Typography>
      <Typography type="body" gutterTop>
        {post.createdAtFormatted}
      </Typography>
    </div>
  </a>
);

const styles = (theme) => ({
  root: {
    display: "flex",
    position: "relative",
    flexFlow: "row wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginBottom: theme.spacing.unit * 0.75,
    width: "100%",
    opacity: "1",
    transition: "all 250ms ease",
    "&:hover": {
      textDecoration: "none",
      opacity: "0.70",
    },
  },
  image: {
    flex: "0 1 100%",
    padding: "0",
    "& img": {
      display: "block",
      maxWidth: "100%",
      height: "auto",
      marginTop: theme.spacing.unit * 0.5,
    },
    [theme.breakpoints(428)]: {
      flex: "0 0 41.66666%",
      padding: "0 15px 0 0",
    },
  },
  content: {
    flex: "0 1 100%",
    padding: "0",
    [theme.breakpoints(428)]: {
      flex: "0 0 58.3333%",
      padding: "0 15px 0 0",
    },
  },
});

export default withStyles(styles)(Post);
